var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c(
      "div",
      { staticClass: "grid-view" },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showMainList,
                expression: "showMainList"
              }
            ],
            staticClass: "main-content",
            attrs: { type: "primary" }
          },
          [
            _c(
              "div",
              {
                staticClass: "cargo-advance-search fcl-search-bar",
                staticStyle: {
                  height: "auto",
                  width: "100%",
                  "margin-top": "5px"
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "section cargo-advance-search-more" },
                  [
                    _c(
                      "el-form",
                      {
                        staticStyle: {
                          "min-width": "830px",
                          "margin-right": "10px"
                        },
                        attrs: {
                          "label-position": "left",
                          "label-width": "80px",
                          inline: true
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "ETD" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "98px" },
                              attrs: {
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                no: "1"
                              },
                              model: {
                                value: _vm.filter.startDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.filter, "startDate", $$v)
                                },
                                expression: "filter.startDate"
                              }
                            }),
                            _c(
                              "span",
                              { staticStyle: { "margin-left": "6px" } },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.To")))]
                            ),
                            _c("el-date-picker", {
                              staticStyle: {
                                width: "98px",
                                "margin-left": "6px"
                              },
                              attrs: {
                                type: "date",
                                "picker-options": _vm.pickerOptions,
                                "value-format": "yyyy-MM-dd",
                                no: "2"
                              },
                              model: {
                                value: _vm.filter.endDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.filter, "endDate", $$v)
                                },
                                expression: "filter.endDate"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("SeaExport.PortOfLoading") }
                          },
                          [
                            _c("cargo-advance-select", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                disabled: _vm.params.visible,
                                filterable: "",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Seaport,
                                "tag-name": "englishName",
                                "tag-value": "code",
                                "default-value": _vm.filter.loadingPort,
                                clearable: "",
                                no: "3"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.filter.loadingPort = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SeaExport.PortOfDestinationPod"),
                              "label-width": "100px"
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                disabled: _vm.params.visible,
                                filterable: "",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Seaport,
                                "tag-name": "englishName",
                                "tag-value": "code",
                                "default-value": _vm.filter.destinationPort,
                                clearable: "",
                                no: "4"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.filter.destinationPort = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SeaExport.ShippingCompany")
                            }
                          },
                          [
                            _c("cargo-company-select", {
                              attrs: {
                                "method-params": {
                                  companyLob: "seaExport",
                                  seaCmp: true,
                                  active: true
                                },
                                "default-value": _vm.filter.carrierId || "",
                                "custom-style": "width:200px;"
                              },
                              on: {
                                change: function(p) {
                                  _vm.filter.carrierId = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("SeaExport.Vessel") } },
                          [
                            _c("cargo-advance-select", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                filterable: "",
                                clearable: "",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Vessel,
                                "tag-name": "englishName",
                                "tag-value": "vesselId",
                                "default-value": _vm.filter.vesselId,
                                no: "5"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.filter.vesselId = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_AirlineCode")
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  clearable: "",
                                  filterable: "",
                                  placeholder: _vm.$t(
                                    "common.defaultPlaceholder"
                                  ),
                                  no: "6"
                                },
                                model: {
                                  value: _vm.filter.routeCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "routeCode", $$v)
                                  },
                                  expression: "filter.routeCode"
                                }
                              },
                              _vm._l(_vm.options, function(item) {
                                return _c("el-option", {
                                  key: item,
                                  attrs: { label: item, value: item }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("CargoMsg.Cargo_VoyageNo") }
                          },
                          [
                            _c("el-input", {
                              attrs: { no: "12" },
                              model: {
                                value: _vm.filter.voyageNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.filter, "voyageNo", $$v)
                                },
                                expression: "filter.voyageNo"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-left": "10px" },
                            attrs: { type: "primary", no: "7" },
                            on: { click: _vm.toQuery }
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("CargoMsg.Cargo_Query")) + " "
                            )
                          ]
                        ),
                        _c(
                          "el-dropdown",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.params.visible,
                                expression: "!params.visible"
                              }
                            ],
                            staticStyle: { "margin-left": "10px" },
                            attrs: {
                              no: "8",
                              "split-button": "",
                              type: "primary"
                            },
                            on: {
                              click: function($event) {
                                return _vm.downloadTemplate()
                              },
                              command: function(p) {
                                _vm.templateCommand = p
                                _vm.downloadTemplate()
                              }
                            }
                          },
                          [
                            _vm.templateCommand ===
                            _vm.$t("SeaExport.ShippingScheduleold")
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.ShippingScheduleold")
                                    )
                                  )
                                ])
                              : _vm._e(),
                            _vm.templateCommand ===
                            _vm.$t("SeaExport.ShippingScheduleNew")
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.ShippingScheduleNew")
                                    )
                                  )
                                ])
                              : _vm._e(),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: {
                                      command: _vm.$t(
                                        "SeaExport.ShippingScheduleold"
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "SeaExport.ShippingScheduleold"
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: {
                                      command: _vm.$t(
                                        "SeaExport.ShippingScheduleNew"
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "SeaExport.ShippingScheduleNew"
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: {
                              "margin-left": "8px",
                              "margin-right": "8px"
                            },
                            attrs: { no: "nonstop" },
                            model: {
                              value: _vm.filter.nonstop,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "nonstop", $$v)
                              },
                              expression: "filter.nonstop"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Nonstop")))]
                        ),
                        _vm.params.pageSource !== "ocr"
                          ? _c(
                              "el-checkbox",
                              {
                                staticStyle: {
                                  "margin-left": "8px",
                                  "margin-right": "8px"
                                },
                                attrs: { no: "internationalRoute" },
                                model: {
                                  value: _vm.filter.internationalRoute,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.filter,
                                      "internationalRoute",
                                      $$v
                                    )
                                  },
                                  expression: "filter.internationalRoute"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_InternationalRoute")
                                  )
                                )
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "el-dropdown",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.params.visible,
                                expression: "!params.visible"
                              }
                            ],
                            staticStyle: { "margin-left": "10px" },
                            attrs: {
                              no: "8",
                              "split-button": "",
                              type: "primary"
                            },
                            on: {
                              command: function(p) {
                                _vm.importCommand = p
                              }
                            }
                          },
                          [
                            _vm.importCommand === _vm.$t("SeaExport.ImportOld")
                              ? _c(
                                  "el-upload",
                                  {
                                    staticStyle: {
                                      display: "inline-block",
                                      "margin-left": "10px"
                                    },
                                    attrs: {
                                      action: _vm.URL.seaExport.importVoyage,
                                      headers: {
                                        sessionId: _vm.sessionId,
                                        language:
                                          _vm.$store.getters.language === "zh"
                                            ? "zh_CN"
                                            : _vm.$store.getters.language ===
                                              "ja"
                                            ? "ja_JP"
                                            : "en_US"
                                      },
                                      "show-file-list": false,
                                      accept: ".xls, .xlsx",
                                      "before-upload": _vm.beforeOrderUpload,
                                      "on-error": _vm.handleError,
                                      "on-success": _vm.uploadExcelSuccess,
                                      data: {
                                        branchId:
                                          _vm.$store.getters.currentOfficeId
                                      },
                                      no: "9"
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "white" } },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("SeaExport.ImportOld"))
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm.importCommand === _vm.$t("SeaExport.ImportNew")
                              ? _c(
                                  "el-upload",
                                  {
                                    staticStyle: {
                                      display: "inline-block",
                                      "margin-left": "5px"
                                    },
                                    attrs: {
                                      action: _vm.URL.seaExport.importVoyageNew,
                                      headers: {
                                        sessionId: _vm.sessionId,
                                        language:
                                          _vm.$store.getters.language === "zh"
                                            ? "zh_CN"
                                            : _vm.$store.getters.language ===
                                              "ja"
                                            ? "ja_JP"
                                            : "en_US"
                                      },
                                      "show-file-list": false,
                                      accept: ".xls, .xlsx",
                                      "before-upload": _vm.beforeOrderUpload,
                                      "on-error": _vm.handleError,
                                      "on-success": _vm.uploadExcelSuccess,
                                      data: {
                                        branchId:
                                          _vm.$store.getters.currentOfficeId
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "white" } },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("SeaExport.ImportNew"))
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: {
                                      command: _vm.$t("SeaExport.ImportOld")
                                    }
                                  },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        ref: "uploadOld",
                                        staticStyle: {
                                          display: "inline-block",
                                          "margin-left": "10px"
                                        },
                                        attrs: {
                                          action:
                                            _vm.URL.seaExport.importVoyage,
                                          headers: {
                                            sessionId: _vm.sessionId,
                                            language:
                                              _vm.$store.getters.language ===
                                              "zh"
                                                ? "zh_CN"
                                                : _vm.$store.getters
                                                    .language === "ja"
                                                ? "ja_JP"
                                                : "en_US"
                                          },
                                          "show-file-list": false,
                                          accept: ".xls, .xlsx",
                                          "before-upload":
                                            _vm.beforeOrderUpload,
                                          "on-error": _vm.handleError,
                                          "on-success": _vm.uploadExcelSuccess,
                                          data: {
                                            branchId:
                                              _vm.$store.getters.currentOfficeId
                                          },
                                          no: "9"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("SeaExport.ImportOld")
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: {
                                      command: _vm.$t("SeaExport.ImportNew")
                                    }
                                  },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        ref: "uploadNew",
                                        staticStyle: {
                                          display: "inline-block",
                                          "margin-left": "10px"
                                        },
                                        attrs: {
                                          action:
                                            _vm.URL.seaExport.importVoyageNew,
                                          headers: {
                                            sessionId: _vm.sessionId,
                                            language:
                                              _vm.$store.getters.language ===
                                              "zh"
                                                ? "zh_CN"
                                                : _vm.$store.getters
                                                    .language === "ja"
                                                ? "ja_JP"
                                                : "en_US"
                                          },
                                          "show-file-list": false,
                                          accept: ".xls, .xlsx",
                                          "before-upload":
                                            _vm.beforeOrderUpload,
                                          "on-error": _vm.handleError,
                                          "on-success": _vm.uploadExcelSuccess,
                                          data: {
                                            branchId:
                                              _vm.$store.getters.currentOfficeId
                                          },
                                          no: "9"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("SeaExport.ImportNew")
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.params.visible,
                                expression: "!params.visible"
                              }
                            ],
                            staticStyle: { "margin-left": "10px" },
                            attrs: { type: "primary", no: "11" },
                            on: { click: _vm.importVoyageResultLog }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("SeaExport.ImportResultLog")) +
                                " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "section grid-wrapper" },
              [
                _c("cargo-ag-grid", {
                  attrs: {
                    "config-module": "310601",
                    "grid-params": _vm.gridParams,
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData
                  },
                  on: {
                    "update:gridParams": function($event) {
                      _vm.gridParams = $event
                    },
                    "update:grid-params": function($event) {
                      _vm.gridParams = $event
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "app-main-inner-row row-pagination" },
              [
                _c("cargo-pagination", {
                  attrs: {
                    "config-module": "310601",
                    total: _vm.filter.total,
                    page: _vm.filter.pageNum,
                    limit: _vm.filter.pageSize
                  },
                  on: {
                    "update:page": function($event) {
                      return _vm.$set(_vm.filter, "pageNum", $event)
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.filter, "pageSize", $event)
                    },
                    pagination: _vm.toQuery
                  }
                })
              ],
              1
            )
          ]
        ),
        _c("import-result", {
          attrs: {
            visible: _vm.importResultDialog.visible,
            result: _vm.importResultDialog.result
          },
          on: {
            continueImporting: _vm.continueImporting,
            close: _vm.closeImportResultDialog
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }